<template>
	<div class="gps-history-view">
		<gmap-map class="map" ref="map" :center="_center" :zoom="_zoom" :options="_options">
			<gmap-custom-marker :key="index" v-for="(event, index) in _my_events" :marker="event.position">
				<svg-marker :type="{
					start: 'driving',
					stop: 'parked',
					enter: 'blue',
					leave: 'green'
				}[event.event]" :label="$options.filters.extractTime(event.logged)" />
			</gmap-custom-marker>

			<gmap-polyline v-for="(line, i) in _colored" :key="i" :path="[line.pos1, line.pos2]" v-bind:options="{ strokeColor: `rgb(${line.r}, ${line.g}, ${line.b})` }" />
		</gmap-map>
		<button-view class="close" label="Luk" @click="close" />
	</div>
</template>

<script>
	import GmapCustomMarker from 'vue2-gmap-custom-marker';
	import SvgMarker from '../SvgMarker'

	export default {
		components: {
			gmapCustomMarker: GmapCustomMarker,
			svgMarker: SvgMarker
		},
		data() {
			return {
				route: []
			};
		},
		props: {
			gps: {
				type: Object
			}
		},
		watch: {
			async gps(n) {
				if (n !== null) {
					this.route = (await this.axios.get(`/fleet/vehicles/${n.vehicle_id}/route/?from=${n.from}&to=${n.to}`)).data;
				} else {
					this.route = [];
				}
			}
		},
		computed: {
			_my_events() {
				const r = this.route.filter((item) => { return item.event !== null; }).map((item) => { 
					if (!['start', 'stop', 'enter', 'leave'].includes(item.event)) 

					return {
						event: 		item.event.toString(),
						logged:		item.logged,
						position: 	{
							lat:	parseFloat(item.lat),
							lng:	parseFloat(item.lng)
						}
					}; 
				});

				return r;
			},
			_center() {
				return {
					lat: 55.679325,
					lng: 12.6026383
				};
			},
			_zoom() {
				return 12;
			},
			_options() {
				return {
					disableDefaultUI: false
				};
			},
			_colored() {
				var poly = this._poly;
				var r = [];

				if (poly.length > 1) {				
					for (var i = 1; i < poly.length; ++i) {
						r.push({
							pos1: poly[i - 1],
							pos2: poly[i],
							r: 255 * (i / poly.length),
							g: 255 * (1 - (i / poly.length)),
							b: 0
						});
					}
				}

				

				return r;
			},
			_poly() {
				const r = this.route.map((item) => {
					return {
						lat:	parseFloat(item.lat),
						lng:	parseFloat(item.lng)
					}; 
				});

				return r;
			}
		},
		methods: {
			close() {
				this.$store.commit('gps', null);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.gps-history-view {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.781);

		& > .map {
			width: 100%;
			height: 100%;
		}

		& > .close {
			position: absolute;
			left: 20px;
			bottom: 20px;
		}
	}
</style>